<template>
  <div>
    <vue-apex-charts type="bar" height="350" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components : {
    VueApexCharts
  },

  created() {
    //this.chartOptions.xaxis.categories = this.categories
  },

  props: {
    series: {},
    categories : {
      default : []
    },
  },

  data: function() {
    return {
      chartOptions: {
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top"
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"]
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"]
        },
        
        colors : ['#8bc34a', '#dc3545'],
        
        xaxis: {
          categories: ['a','b']
        }
      }
    };
  },

  watch : {
    categories (val) {
     
    }
  }
};
</script>

<style>
</style>